module.exports = __webpack_public_path__ + "img/value.3eff1132.svg";